/**
 * Automatically adjust markup to better suit people with disabilities.
 */
function delegate(event, selector, callback) {
    document.addEventListener(
        event,
        (evt) => {
            const elem = evt.target.closest(selector);
            if (elem) {
                callback(evt, elem);
            }
        },
        true,
    );
}

export const init = () => {
    srOnlyInputFocus();
    blurOnESC();
};

// Make it so that if an input is ever focused, while inside of an
// element with a class of sr-only (in that it should only be visible to
// a screen reader) we make sure to show the element (otherwise it would
// be confusing for a sighted reader that is focusing on an element that
// they can't see!)
export const srOnlyInputFocus = () => {
    delegate("focus", ".sr-only input, .sr-only a", (evt, elem) => {
        const srOnly = elem.closest(".sr-only");
        if (srOnly) {
            srOnly.classList.toggle("sr-only");
            srOnly.classList.toggle("sr-only-visible");
        }
    });

    delegate(
        "blur",
        ".sr-only-visible input, .sr-only-visible a",
        (evt, elem) => {
            const srOnly = elem.closest(".sr-only-visible");
            if (srOnly) {
                srOnly.classList.toggle("sr-only");
                srOnly.classList.toggle("sr-only-visible");
            }
        },
    );
};

// Make it so that input elements can optionally be blurred when the
// ESC key is pressed, improving their usability.
export const blurOnESC = () => {
    delegate("keyup", "input.blur-on-esc", (e) => {
        if (e.which === 27) {
            e.target.blur();
        }
    });
};
